<div class="header-container">
  <div class="header">
    @for (col of columns; track col) {
      <div
        class="header-cell"
        (click)="changeSort($any(col.sort))"
        [class.sortable]="col.sort"
        [class.current-sort]="col.sort === filter?.sort?.field"
        [style.width]="col.colWidth ? col.colWidth + 'px' : col.calculatedPercentage + '%'"
      >
        @if (col.toggleAll) {
          <span class="custom-checkbox" title="Select all">
            <label>
              <input type="checkbox" value="" (click)="changeToggleAll(col.toggleAll)" />
              <ng-container [ngTemplateOutlet]="toggleTemplate" [ngTemplateOutletContext]="{toggle: col.toggleAll}"></ng-container>
            </label>
          </span>
        }
        @if (col.toggleCurrentPage) {
          <span class="custom-checkbox" title="Select current page">
            <label>
              <input type="checkbox" value="" (click)="changeToggleCurrentPage(col.toggleCurrentPage)" />
              <ng-container [ngTemplateOutlet]="toggleTemplate" [ngTemplateOutletContext]="{toggle: col.toggleCurrentPage}"></ng-container>
            </label>
          </span>
        }
        <div class="col-label">{{ col.name }}</div>
        <i class="sort-icon" [ngClass]="getSortIcon(col.sort!)"></i>
        <i class="sort-hover fas fa-arrow-down"></i>
      </div>
    }
  </div>
</div>

<ng-template #toggleTemplate let-toggle="toggle">
  <span [class.selected]="isToggleSelected(toggle)">
    @if (toggle.status === undefined) {
      <i [ngClass]="Icons.MINUS" class="toggle-icon"></i>
    }
    @if (toggle.status === true) {
      <i [ngClass]="Icons.CHECK" class="toggle-icon"></i>
    }
  </span>
</ng-template>
